import { createStore } from "vuex";
import jwt_decode from "jwt-decode";
import swal from "sweetalert";

export default createStore({
  state: {
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    sidebarType: "bg-white",
    isRTL: false,
    mcolor: "",
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    openAlert: false,
    layout: "default",
    
    userToken: '',
    user: '',
    selectedBatchUpload: '',
    selectedStationUnit: '',
    isLoading: false,
    isLoadingDownload: false,
  },
  mutations: {
    toggleConfigurator(state) {
      state.showConfig = !state.showConfig;
    },
    navbarMinimize(state) {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (sidenav_show.classList.contains("g-sidenav-hidden") || sidenav_show.classList.length < 2) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        state.isPinned = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        state.isPinned = false;
      }
    },
    sidebarType(state, payload) {
      state.sidebarType = payload;
    },
    navbarFixed(state) {
      if (state.isNavFixed === false) {
        state.isNavFixed = true;
      } else {
        state.isNavFixed = false;
      }
    },
    user(state, user) {
      state.userToken = user;
    },
    swalConfirm(state, payload) {
      swal({
        icon: "warning",
        title: "Apakah Anda Yakin ?",
        text: payload.text,
        buttons: {
          ya: "Ya",
          cancel: "Batalkan"
        }
      }).then(async (val) => {
        switch (val) {
          case "ya":
            try {
              await payload.funs();
            } catch (error) {
              swal({
                icon: "success",
                title: `Error`,
              });
            }
            break;
          default:
            break;
        }
      })
    },
    swalSuccess(state, payload) {
      swal({
        icon: "success",
        title: "Berhasil",
        text: payload.text
      });
    },
    swalError(state, payload) {
      swal({
        icon: "error",
        title: `${payload.code} Error`,
        text: payload.text
      });
    },
    swalErrorDownload() {
      swal({
        icon: "error",
        title: "Data terlalu banyak !",
        text: "Input terlebih dahulu filter sebelum melakukan pencetakan"
      });
    },
    getToken(state) {
      if (!state.userToken) {
        state.userToken = localStorage.getItem("user");
      }
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    },
    user(context, user) {
      context.commit('user', user);
    },
    swal() {
      swal("hello world").then(() => {
        this.state.openAlert = false
      })
    },
    swalConfirm(context, payload) {
      context.commit('swalConfirm', payload);
    },
    swalSuccess(context, payload) {
      context.commit('swalSuccess', payload);
    },
    swalError(context, payload) {
      context.commit('swalError', payload);
    },
    swalErrorDownload(context) {
      context.commit('swalErrorDownload');
    },
    setToken(context) {
      context.commit('getToken');
    }
  },
  getters: {
    user: state => state.user,
  }
});
